module.exports = __webpack_public_path__ + "static/media/close.67a7501b.svg";